<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5-tablet is-4-desktop is-3-widescreen">
            <form class="box" @submit.prevent="login">
              <div class="field">
                <label for="" class="label">ログインID</label>
                <div class="control has-icons-left">
                  <input type="text" placeholder="ログインID" class="input" v-model="loginForm.login_id" required>
                  <span class="icon is-small is-left">
                    <i class="fa fa-user-friends"></i>
                  </span>
                </div>
              </div>
              <div class="field">
                <label for="" class="label">パスワード</label>
                <div class="control has-icons-left">
                  <input type="password" placeholder="*******" class="input" v-model="loginForm.password" required>
                  <span class="icon is-small is-left">
                    <i class="fa fa-lock"></i>
                  </span>
                </div>
              </div>
              <div v-if="loginErrors">
                <p >
                  <span class="has-text-danger">{{ loginErrors }}</span>
                </p>
              </div>
              <div class="field">
                  <button type="submit" class="button is-success">ログイン</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'   //Vuex が提供する mapState 関数を使う

export default {
  data () {
    return {
      loginForm: {
        login_id: '',
        password: '',
      }
    }
  },
  computed: {
    ...mapState({
      apiStatus: state => state.auth.apiStatus,
      loginErrors: state => state.auth.loginErrorMessages,
    })
  },
  created () {
    this.clearError()
  },
  methods: {
    async login(){
      this.clearError()
      // authストアのloginアクションを呼び出す
      await this.$store.dispatch('auth/login', this.loginForm)
      
      if(this.apiStatus){
        //ページに移動する
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push({ path: '/' });
        }
      }
    },
    clearError () {
      this.$store.commit('auth/setLoginErrorMessages', null)
    }
  },
}
</script>